import request from '@/utils/request'
export function diyReport(query) {
  return request({
    url: "/ntocc-tms-api/diyReport",
    method: 'get',
    params: query
  })
}

export function diyReportField(query) {
  return request({
    url: "/ntocc-tms-api/diyReportField",
    method: 'get',
    params: query
  })
}

